import { render } from "./Channel.vue?vue&type=template&id=a3c4687e&ts=true"
import script from "./Channel.vue?vue&type=script&lang=ts"
export * from "./Channel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__